<template>
    <div>
        <div class="title">
            <div  :class="{ hovers: clickclassif == 1 }" @click="clickclassfun('1','Enterpriseregistration')">企业用户注册</div>
            <div  :class="{ hovers: clickclassif == 2 }" @click="clickclassfun('2','Personalregistration')">个人用户注册</div>
        </div>
        <component :is="componentName"></component>
    </div>
</template>

<script>
import Enterpriseregistration from './Enterprise_registration'
import Personalregistration from './Personal_registration'
export default {
  data () {
    return {
      clickclassif: 1,
      componentName: 'Enterpriseregistration'
    }
  },
  components: {
    Enterpriseregistration,
    Personalregistration
  },
  methods: {
    clickclassfun (k, v) {
      this.clickclassif = k
      this.componentName = v
    }
  }
}
</script>

<style lang="scss" scoped>
  .title {
    // font-size: 36px;
    font-size: 25px;
    color: black;
    margin-top: 50px;
    text-align: center;
    display: flex;
    justify-content: center;
    border-bottom:1px solid #d43c33;
    height: 55px;
    div{
      width: 300px;
      margin-left:100px;
      line-height: 55px;
    }
    .hovers{
      color: #fff;
      background: #d43c33;
    }
  }
</style>
